<template>
  <div>
    <fcc-botoes-navegacao right :rightDisabled="buttonDisabled" @proximo="$emit('proximo')" />

    <fcc-table
      striped
      hover
      responsive
      pagination
      :items="lista"
      :fields="fields"
      @row-selected="selecionaItens"
    />
  </div>
</template>
<script>
import fccBotoesNavegacao from './fccBotoesNavegacao.vue'
export default {
  components: { fccBotoesNavegacao },
  props: {
    lista: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      buttonDisabled: true,
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'data', label: 'Data', sortable: true },
        { key: 'horaapres', label: 'Hora de Apresentação', sortable: true },
        { key: 'periodo', label: 'Período', sortable: true }
      ]
    }
  },

  methods: {
    selecionaItens(itens) {
      this.buttonDisabled = itens.length === 0
      this.$emit(
        'seleciona-itens',
        itens.map((item) => item.iddata).reduce((acc, curr) => curr + (acc ? `,${acc}` : ''), '')
      )
    }
  }
}
</script>
